const RELOAD_KEY = 'rs-stale-chunk-reload'

export function isStaleChunkError (err: unknown): boolean {
  const message = err instanceof Error ? err.message : String(err ?? '')
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk [\w.-]+ failed|Expected a JavaScript module script but the server responded with a MIME type of "text\/html"/i.test(message)
}

/**
 * After a deploy, a tab can keep an old index that imports hashed files
 * that no longer exist (SPA fallback then returns HTML). Drop the service
 * worker + caches and reload once.
 */
export async function recoverFromStaleChunk (): Promise<boolean> {
  if (typeof window === 'undefined') return false
  try {
    if (sessionStorage.getItem(RELOAD_KEY) === '1') return false
    sessionStorage.setItem(RELOAD_KEY, '1')
  } catch {
    return false
  }

  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((reg) => reg.unregister()))
    }
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map((key) => caches.delete(key)))
    }
  } catch {
    // Still reload — a hard refresh is better than a dead shell.
  }

  window.location.reload()
  return true
}
